// VIRGO
import {
  middlewares,
  normalizeSchema,
  reducers,
  structures,
  utils,
  constants,
  actions,
} from 'virgo';

const { actionTypes } = actions;
const {
  middlewareNormalizeDataGenerator,
  middlewareReStructureResponses,
  middlewareStructureGenerator,
} = middlewares;

// LIB
import thunkMiddleware from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

// REDUX
import { applyMiddleware, combineReducers, createStore, compose } from 'redux';
import { arrayOf } from 'normalizr';

// CUSTOM LOCAL
import customReducers from 'flux/reducers';
import parserHTML from 'js/lib/parserHTML';
import config from 'js/config';
Object.assign(constants, {
  API_PATH: `${config.build.apiPath}/api/`,
  SOLARIS_API_PATH: `${config.build.apiPath}/public/`,
  WS_URL: config.build.meteorUrl,
  WS_PATH: config.build.meteorPath,

  CDN: {
    img: config.build.imagesPath,
    POST_IMG: `${config.build.imagesPath}/post/post_`,
    communityLogos: `${config.build.imagesPath}/group-logos/`,
    communityBanners: `${config.build.imagesPath}/group-banners/`,
    AVATARS: `${config.build.imagesPath}/avatars/`,
    GROUPS: `${config.build.imagesPath}/group-logos/`,
    emoji: `${config.build.assetPath}/betelgeuse/img/emoji/unicode/`,
    smiley: `${config.build.assetPath}/aurora/images/smiley/`,
  },

  DEFAULT_BANNER_URL: `${config.build.assetPath}/betelgeuse/img/gallery/default-banner_1170x250.png`,
});

const customNormalizeSchema = {
  groups: arrayOf(normalizeSchema.group),
  notifications: arrayOf(normalizeSchema.notification),
  posts: arrayOf(normalizeSchema.post),
  users: arrayOf(normalizeSchema.user),
};
const structuresSchema = {
  groups: structures.groupStructure,
  notifications: structures.notificationStructure,
  posts: structures.postStructure,
  users: structures.userStructure,
};
const assign = options => utils.enrichedAssign(parserHTML.getElement, options);

const appReducer = combineReducers({
  ...reducers,
  appState: combineReducers(reducers.appState),
  data: combineReducers({
    ...reducers.data,
    posts: reducers.data.posts(assign({})),
  }),
  temporaryData: combineReducers(reducers.temporaryData),
  ...customReducers,
  form: formReducer,
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOG_OUT) {
    state = undefined;
  }
  return appReducer(state, action);
};

const store = createStore(
  rootReducer,
  {},
  compose(
    applyMiddleware(
      thunkMiddleware,
      middlewareReStructureResponses,
      middlewareNormalizeDataGenerator(customNormalizeSchema),
      middlewareStructureGenerator(structuresSchema)
    ),
    // window.devToolsExtension && window.devToolsExtension()
  )
);

export default store;



// WEBPACK FOOTER //
// ./app/assets/flux/instance.js